define('views/filefinder/Podio.Views.FileFinderAccountsList',['require','underscore','jquery','lib/backbone/Backbone.PodioView','lib/Podio.Config','jst!filefinder/_account','jst!filefinder/_account_tip'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var podioConfig = require('lib/Podio.Config');

  var jstAccount = require('jst!filefinder/_account');
  var jstAccountTip = require('jst!filefinder/_account_tip');

  return ViewPodioBase.extend({
    podioEvents : {
      'click li' : 'onTabsTabClick',
      'click .account-tip' : 'onAccountTipClick'
    },

    initialize : function(options) {
      _.bindAll(this, 'render', 'renderTip', 'renderAccounts', 'onTabsTabClick', 'selectTab');

      this.podioDelegateEvents();

      this.elm = $(this.el);
      this.elmList = options.elmList;

      this.eventBridge = options.eventBridge;

      this.model.bind('reset', this.renderAccounts);
      this.model.bind('change', this.renderAccounts);

      this.accountsMap = {};
    },

    render : function() {
      var html = [];
      var self = this;

      _.each(this.model.models, function(account) {
        var providerName = account.get('provider');

        if ( !self.accountsMap[providerName] ) {

          self.accountsMap[providerName] = {
            'provider' : providerName,
            'provider_humanized_name' : account.get('capability_names')['files'],
            'icon' : account.get('icon')
          };

          var accountHtml = self.getTemplate(jstAccount, {
            account: self.accountsMap[providerName]
          });

          html.push(accountHtml);
        }
      });

      this.elmList.append( html.join('') );

      this.elm.find('.providers-tab').toggleClass('faded', this.model.models.length > 0);
      this.elmTip = this.elm.find('.account-tip');

      return this;
    },

    renderAccounts: function() {
      if ( this.model.length < 2 ) {
        this.renderTip();
      } else {
        this.removeTip();
      }

      this.render();

    },

    renderTip: function() {
      if ( this.elmTip.length || podioConfig.user.from_sharefile) {
        return;
      }

      var elmTip = $(this.getTemplate(jstAccountTip, {}));
      elmTip.appendTo( this.elm );

    },

    removeTip: function() {
      this.elmTip.remove();
    },

    dispose: function() {
      this.remove();
    },

    selectTab : function(providerName) {
      var elmTab = this.elm.find('.{0}-tab'.format(providerName) );

      elmTab.addClass('selected');

      this.elm.find('li').not(elmTab).removeClass('selected');
    },

    onTabsTabClick : function(elmTarget, e) {
      var tabName = elmTarget.data('tab-name');

      if (tabName === 'providers') {
        this.eventBridge.trigger('addProvider');
        return;
      }

      if (tabName === 'upload') {
        this.eventBridge.trigger('changeUploadTab');
        return;
      }

      var account = this.model.find(function(item) {
        return item.get('provider') === tabName;
      });

      this.eventBridge.trigger('changeTab', account);
    },

    onAccountTipClick: function() {
      this.eventBridge.trigger('addProvider');
    }

  });


});

